import api from '@edu-fe/api'

const module = {
  name: 'custom',
  push: (pushMin, type, switchType = 1) => api.create(`/course/custom/push?pushMin=${pushMin}&type=${type}&switchType=${switchType}`),
  getInfo: api.create(`/course/custom/push/info?type=1`),
  switch: api.create(`course/custom/switch`)
}

export default module
